import { generate } from '@/utils/request';
const config = {
  prefix: '/lgit/v1/{organizationId}',
  items: [
    // 物流产品 == 产品类型下拉框数据   get /v1/{organizationId}/param-values/list
    { key: 'getLogisticProductTypeList', url: '/param-values/list', method: 'get' },

    // 订单 =>>> 应收、应付 汇总列表数据           post /v1/{organizationId}/supplier-logistics-quote-cost-details/pageList
    { key: 'getOrderQuateCost', url: '/supplier-logistics-quote-cost-details/pageList', method: 'post' },
    // 订单 =>>> 应收、应付 明细列表数据           post /v1/{organizationId}/supplier-logistics-quote-cost-details/detail/pageList
    { key: 'getOrderQuateDetail', url: '/supplier-logistics-quote-cost-details/detail/pageList', method: 'post' },
    // 订单 =>>> 应收、应付 顶部卡片           post /v1/{organizationId}/supplier-logistics-quote-cost-details/summary
    { key: 'getOrderQuateCard', url: '/supplier-logistics-quote-cost-details/summary', method: 'post', cType: 4 },
    // 订单 =>>> 应收、应付 批量删除           post /v1/{organizationId}/supplier-logistics-quote-cost-details/delete
    { key: 'delOrderQuateCost', url: '/supplier-logistics-quote-cost-details/delete', method: 'post' },
    // 订单 =>>> 应收、应付 批量确认           post /v1/{organizationId}/supplier-logistics-quote-cost-details/confirm
    { key: 'doneOrderQuateCost', url: '/supplier-logistics-quote-cost-details/confirm', method: 'post' },
    // 订单 =>>> 应收、应付 费用重算           post /v1/{organizationId}/supplier-logistics-quote-cost-details/refresh
    { key: 'refreshOrderQuateCost', url: '/supplier-logistics-quote-cost-details/refresh', method: 'post', cType: 4 },
    // 订单 =>>> 应收、应付 新增               post /v1/{organizationId}/supplier-logistics-quote-cost-details/add
    { key: 'addOrderQuateCost', url: '/supplier-logistics-quote-cost-details/add', method: 'post' },
    // 订单 =>>> 应收、应付 编辑               post /v1/{organizationId}/supplier-logistics-quote-cost-details/update
    { key: 'editOrderQuateCost', url: '/supplier-logistics-quote-cost-details/update', method: 'post' },
    // 订单 =>>> 应收、应付 结算对象下拉框      post /v1/{organizationId}/supplier-logistics-quote-cost-details/order-customers
    { key: 'getOrderQuatePackage', url: '/supplier-logistics-quote-cost-details/order-customers', method: 'post', cType: 4 },

    // 燃油附加费费率维护 列表      post /v1/{organizationId}/fuel-surcharges/pageList
    { key: 'getFuelSurcharges', url: '/fuel-surcharges/pageList', method: 'post' },
    // 燃油附加费费率维护 新增      post /v1/{organizationId}/fuel-surcharges/add
    { key: 'addFuelSurcharge', url: '/fuel-surcharges/add', method: 'post' },
    // 燃油附加费费率维护 编辑      post /v1/{organizationId}/fuel-surcharges/update
    { key: 'updateFuelSurcharge', url: '/fuel-surcharges/update', method: 'post' },
    // 燃油附加费费率维护 批量删除  delete /v1/{organizationId}/fuel-surcharges/delete
    { key: 'deleteFuelSurcharge', url: '/fuel-surcharges/delete', method: 'delete' },
    // 燃油附加费费率维护 导入      post /v1/{organizationId}/fuel-surcharges/import
    { key: 'importFuelSurcharges', url: '/fuel-surcharges/import', method: 'post', cType: 2, timeout: 10 * 60 * 1000 },
    // 燃油附加费费率维护 停用/启用      post /v1/{organizationId}/fuel-surcharges/batch-update-status
    { key: 'updateFuelSurchargeStatus', url: '/fuel-surcharges/batch-update-status', method: 'post' },

    // 汇率维护 列表     post /v1/{organizationId}/exchange-rates/pageList
    { key: 'getExchangeRates', url: '/exchange-rates/pageList', method: 'post' },
  ],
};
export default {
  ...generate(config),
};
